export enum DownloadReportStatus {
  INCOMPLETE = 'INCOMPLETE',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
}
